module.exports = __webpack_public_path__ + "img/generica_fall.15f304ed.svg";